/**
 * Keycloak configuration and initialization
 */
import Keycloak from 'keycloak-js'

// Keycloak instance configuration
const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_DOMAIN,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_FACING_CLIENT_ID,
}

// Log configuration (without sensitive data)
console.log('Keycloak configuration:', {
  url: keycloakConfig.url,
  realm: keycloakConfig.realm,
  clientId: keycloakConfig.clientId,
})

// Create Keycloak instance - use singleton pattern to avoid re-initialization
let keycloakInstance: Keycloak | null = null

export const getKeycloakInstance = (): Keycloak => {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak(keycloakConfig)
  }
  return keycloakInstance
}

// Export the instance
export const keycloak = getKeycloakInstance()

// Keycloak initialization options
export const keycloakInitOptions = {
  onLoad: 'check-sso' as const,
  checkLoginIframe: false,
  pkceMethod: 'S256' as const,
}
